export const PayoutBeneficiaryFilters = {
  MY_COMPANY: 'my-company',
  BUSINESS: 'business',
  INDIVIDUAL: 'individual',
}

export type PayoutBeneficiaryFilter =
  (typeof PayoutBeneficiaryFilters)[keyof typeof PayoutBeneficiaryFilters]

export const MAX_GBP_PAYMENT_AMOUNT = 1000000
